<template lang="pug">
  .gvl-finish
    h2.text-center.py-10 Vielen Dank,<br>Ihr Vertrag wurde abgesendet.
    v-btn.mt-5(block color="primary" @click="onGotoStart") zurück zur Startseite

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ]
})
export default class Finish extends Vue {
  created () {
    this.$store.dispatch('setSignMode', true)
  }

  onGotoStart () {
    this.$store.dispatch('setSignMode', false)
    this.gotoRoute('home')
  }
}
</script>
